
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs/operators';

export const authGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (authService.isInitialized()) {
        return authService.isAuthenticated() ? true : router.createUrlTree(['/login']);
    }

    return toObservable(authService.isInitialized).pipe(
        filter(Boolean),
        take(1),
        map(() => authService.isAuthenticated() ? true : router.createUrlTree(['/login'])),
    );
};
